import React from 'react';
import { TFunction } from 'i18next';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import CommonMobileModal from '../../common/CommonMobileModal';
import NewPhotoForm from '../NewPhotoForm';
import { addNewPhoto } from '../../../actions/photosActions';

const iconCamera = require('../../../images/icons/icon-camera.svg').default;

interface IProps {
    getShowCameraComponent: (handleClose: () => void) => JSX.Element | null;
    getAttachImageComponent: () => JSX.Element | null;
    showAddNewPhotoModal: boolean;
    onAddNewModalHide: () => void;
    t: TFunction;
    addNewPhoto: typeof addNewPhoto;
    images: { id: string; url: string }[];
    installBaseID: string;
    showCamera: boolean;
    handleCameraOpen: () => void;
    handleCameraClose: () => void;
    showHistoricalImagesModal: () => void;
}

const ButtonSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    @media (min-width: 768px) {
        flex-direction: row;
        gap: 12px;
    }
`;

const MobileButton = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`;

export default (props: IProps) => {
    return (
        <div className="take-photo-control">
            {!props.showAddNewPhotoModal && (
                <ButtonSection>
                    <MobileButton variant="primary" onClick={props.handleCameraOpen}>
                        <img src={iconCamera} />
                        <span>Add New Image</span>
                    </MobileButton>
                    {props.getAttachImageComponent()}
                    <MobileButton variant="primary" onClick={props.showHistoricalImagesModal}>
                        {props.t('historicalImagesButton')}
                    </MobileButton>
                </ButtonSection>
            )}
            {/* Camera rendering moved to parent component to persist across orientation changes */}
            <CommonMobileModal
                show={props.showAddNewPhotoModal}
                onHide={() => props.onAddNewModalHide()}
                className="add-photo-modal"
                title="Add Image"
            >
                <NewPhotoForm
                    images={props.images}
                    t={props.t}
                    loading={false}
                    installBaseID={props.installBaseID}
                    addNewPhoto={props.addNewPhoto}
                    toggleModal={props.onAddNewModalHide}
                />
            </CommonMobileModal>
        </div>
    );
};
